<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header class="card-menu">
        <span class="breadcrumbs"><b-link :to="{name: `${collection}s`}">Image Templates</b-link> / {{item ? item.name : ''}}</span>
        <!-- <b-button size="sm" class="float-right" :to="{name: `${collection}_edit`, params: {from_item: item}}">Edit</b-button> -->

        <!-- <b-dropdown size='sm' text="Integrate" class="float-right mr-2">
          <template #button-content>
            <i class="fad fa-plug"></i> Integrate
          </template>

          <b-dropdown-item :to="{name: `image_template_integrate`, params: {from_item: item, integration: 'hubspot'}}">HubSpot sequence</b-dropdown-item>
          <b-dropdown-item :to="{name: `image_template_integrate`, params: {from_item: item, integration: 'reply'}}">Reply.io</b-dropdown-item>
          <b-dropdown-item :to="{name: `image_template_integrate`, params: {from_item: item, integration: 'prospect.io'}}">Prospect</b-dropdown-item>
          <b-dropdown-item :to="{name: `image_template_integrate`, params: {from_item: item, integration: 'close.io'}}">Close.io</b-dropdown-item>
          <b-dropdown-item :to="{name: `image_template_integrate`, params: {from_item: item, integration: 'persistIQ'}}">PersistIQ</b-dropdown-item>
          <b-dropdown-item :to="{name: `image_template_integrate`, params: {from_item: item, integration: 'salesforce'}}">Salesforce</b-dropdown-item>
          <b-dropdown-item :to="{name: `image_template_integrate`, params: {from_item: item, integration: 'salesloft'}}">SalesLoft</b-dropdown-item>
          <b-dropdown-item :to="{name: `image_template_integrate`, params: {from_item: item, integration: 'outreach.io'}}">Outreach.io</b-dropdown-item>
          <b-dropdown-item :to="{name: `image_template_integrate`, params: {from_item: item, integration: 'mixmax'}}">Mixmax</b-dropdown-item>
          <b-dropdown-item :to="{name: `image_template_integrate`, params: {from_item: item, integration: 'linkedin_automation'}}">LinkedIn</b-dropdown-item>
          <b-dropdown-item :to="{name: `image_template_integrate`, params: {from_item: item, integration: 'other'}}">Other email</b-dropdown-item>
        </b-dropdown> -->

        <b-button v-if="profile.role === 'admin'" size="sm" class="float-right mr-2" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Fimage_template~2F${$route.params.id}`" target="_blank"><i class="fas fa-database"></i></b-button>
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>
        <b-alert variant="warning" :show="item.status == constants.item_status.error"><strong>An error occured:</strong> {{item.error_message}}</b-alert>
        <b-alert variant="danger" :show="item.status == constants.item_status.deleted"><strong>Deleted:</strong> This image template was deleted</b-alert>

        <img :src="item.image" />
      </div>
    </b-card>

    <keep-alive include="project_item_list">
      <router-view :profile="profile" :user="user" :image_template="item" v-if="item && item.name"/>
    </keep-alive>

  </b-container>
</template>

<script>
/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */

import { db } from '@/main.js'
import ItemMixin from "@/mixins/Item.js"

export default {
  metaInfo: {title: 'Video'},
  props: ['profile', 'user'],
  mixins: [ItemMixin],
  firestore: function () {
    return {
      item: db.collection(this.collection).doc(this.$route.params.id),
    }
  },
  data() {
    return {
      collection: 'image_template'
    }
  },
}
</script>

<style>

</style>
